export enum IdentityType {
  personal,
  company,
}

export const VISITOR_TOKEN_STORAGE_KEY = "visitor_token";